import React from 'react';
import { motion } from 'framer-motion';
export function CTA() {
  return <section id="kontakt" className="w-full bg-white py-24 px-6 scroll-mt-20" data-id="element-67" data-mp="1lh1hbthvpshk">
      <div className="max-w-4xl mx-auto" data-id="element-68" data-mp="1lj45e7zh1bjn">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-br from-mist to-white rounded-2xl p-12 md:p-16 text-center shadow-lg border border-mist/50" data-id="element-69" data-mp="1zhc7eubd731o">
          {/* Sail logomark — navy SVG, plain img on light bg */}
          <img src="https://cdn.magicpatterns.com/uploads/oR2yze7yVUcg2uRAatZj5v/FCh_logo_Blue.svg" alt="Future Challenge logo" width="64" height="64" className="h-16 w-auto block mx-auto mb-8 opacity-80" data-id="element-70" data-mp="1bqye70h1my5i" />

          <h2 className="text-3xl md:text-4xl font-light text-navy-deep mb-6" data-id="element-71" data-mp="33emwbmk42cm1">
            Doplňující informace
          </h2>

          <div className="text-lg text-navy-deep/70 leading-relaxed mb-10 space-y-4 max-w-2xl mx-auto" data-id="element-72" data-mp="38cg2wgpbt8mu">
            <p data-id="element-73" data-mp="3d59ardg3cx35">
              Organizace akce bude koncipována tak, že není nutná přítomnost
              posádek fyzicky na jednom místě nebo skipper meetincích. Veškeré
              informace potřebné k platné účasti budou předávány elektronickou
              formou s dostatečným předstihem do společné WhatsApp skupiny
              kapitánů.
            </p>
            <p data-id="element-74" data-mp="2tggwdahv7gjt">
              Organizátor nabídne v průběhu akce i pár „workshopů“ na různá
              témata dle zájmů posádek. Nabyté dovednosti tak budete moci ihned
              uplatnit v praxi.
            </p>
          </div>

          <div className="pt-8 border-t border-mist/80" data-id="element-75" data-mp="8p6nd8yredts">
            <p className="text-xl font-serif-italic text-blue-medium mb-4" data-id="element-76" data-mp="dot0zjii1w34">
              „S přáním stálého větru alespoň stopu pod kýlem a pozitivních
              zážitků."
            </p>
            <p className="font-semibold text-navy-deep tracking-wide uppercase text-sm" data-id="element-77" data-mp="25qma7ep2etez">
              — FUTURE Challenge Crew
            </p>
          </div>

          <div className="mt-10 pt-8 border-t border-mist/80 flex flex-col sm:flex-row justify-center gap-8 sm:gap-16" data-id="element-78" data-mp="2jpvg9ljk4758">
            {[{
            name: 'Jarda Kašpar',
            phone: '603 238 888',
            src: 'https://cdn.magicpatterns.com/uploads/ghXDifhMo9Sc8g1usZWyEQ/jarda.png'
          }, {
            name: 'Radek Dlouhý',
            phone: '777 568 826',
            src: 'https://cdn.magicpatterns.com/uploads/owbyLXVt9qeHiPpLZpJS74/radekII.png'
          }].map(person => <div key={person.name} className="flex flex-col items-center gap-3" data-id="element-79" data-mp="18a6u2we4nc5h">
                <img src={person.src} alt={person.name} width="112" height="112" className="h-28 w-28 rounded-full object-cover" data-id="element-80" data-mp="13bvl0nvnp5ob" />
                <div data-id="element-81" data-mp="35z2jaa8rhnqv">
                  <p className="font-semibold text-navy-deep" data-id="element-82" data-mp="35zu2smp33v0s">{person.name}</p>
                  <a href={`tel:+420${person.phone.replace(/\s/g, '')}`} className="text-navy-deep/70 hover:text-blue-medium transition-colors" data-id="element-83" data-mp="39zw6f1edqyip">
                    tel.: {person.phone}
                  </a>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}